import { useContext } from "react";
import { PageDataContext } from "../providers/PageDataProvider";

export default function usePageData() {
  const contextValue = useContext(PageDataContext);
  return contextValue;
}